import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert } from '@guildeducationinc/recess';
import { Box, Typography } from '@mui/material';
import { useLocale } from 'pe-core-frontend';
import React from 'react';
import styles from './AiSummary.module.scss';
import { PromptCategory, } from './typesAi';
function handleValidationResponse(aiSummaryResponseItems) {
    return aiSummaryResponseItems.map(item => {
        const baseResponse = {
            error: item.llmResponse.error ||
                item.llmResponse.response?.error ||
                item.llmResponse.response?.text ||
                '',
        };
        const informationPresence = {
            school: item.llmResponse.information_presence?.school ||
                item.llmResponse.response?.information_presence?.school ||
                {},
            program: item.llmResponse.information_presence?.program ||
                item.llmResponse.response?.information_presence?.program ||
                {},
            fieldOfStudy: item.llmResponse.information_presence?.field_of_study ||
                item.llmResponse.response?.information_presence?.field_of_study ||
                {},
            programLevel: item.llmResponse.information_presence?.program_level ||
                item.llmResponse.response?.information_presence?.program_level ||
                {},
            startDate: item.llmResponse.information_presence?.start_date ||
                item.llmResponse.response?.information_presence?.start_date ||
                '',
            endDate: item.llmResponse.information_presence?.end_date ||
                item.llmResponse.response?.information_presence?.end_date ||
                '',
            completionStatus: item.llmResponse.information_presence?.completion_status ||
                item.llmResponse.response?.information_presence?.completion_status ||
                '',
            employeeName: item.llmResponse.information_presence?.employee_name ||
                item.llmResponse.response?.information_presence?.employee_name ||
                {},
            totalAmount: item.llmResponse.information_presence?.total_amount ||
                item.llmResponse.response?.information_presence?.total_amount ||
                {},
            termStartDate: item.llmResponse.information_presence?.term_start_date ||
                item.llmResponse.response?.information_presence?.term_start_date ||
                {},
            termEndDate: item.llmResponse.information_presence?.term_end_date ||
                item.llmResponse.response?.information_presence?.term_end_date ||
                {},
            courses: item.llmResponse.information_presence?.courses ||
                item.llmResponse.response?.information_presence?.courses ||
                {},
            books: item.llmResponse.information_presence?.books ||
                item.llmResponse.response?.information_presence?.books ||
                {},
            fees: item.llmResponse.information_presence?.fees ||
                item.llmResponse.response?.information_presence?.fees ||
                {},
            materials: item.llmResponse.information_presence?.materials ||
                item.llmResponse.response?.information_presence?.materials ||
                {},
            scholarships: item.llmResponse.information_presence?.scholarships ||
                item.llmResponse.response?.information_presence?.scholarships ||
                {},
        };
        const documentPresence = {
            proofOfEnrollments: item.llmResponse.document_presence?.proof_of_enrollments ||
                item.llmResponse.response?.document_presence?.proof_of_enrollments ||
                [],
            proofOfCompletions: item.llmResponse.document_presence?.proof_of_completions ||
                item.llmResponse.response?.document_presence?.proof_of_completions ||
                [],
            proofOfPayments: item.llmResponse.document_presence?.proof_of_payments ||
                item.llmResponse.response?.document_presence?.proof_of_payments ||
                [],
            tuitionBills: item.llmResponse.document_presence?.tuition_bills ||
                item.llmResponse.response?.document_presence?.tuition_bills ||
                [],
            receipts: item.llmResponse.document_presence?.receipts ||
                item.llmResponse.response?.document_presence?.receipts ||
                [],
            transcripts: item.llmResponse.document_presence?.transcripts ||
                item.llmResponse.response?.document_presence?.transcripts ||
                [],
            syllabi: item.llmResponse.document_presence?.syllabi ||
                item.llmResponse.response?.document_presence?.syllabi ||
                [],
        };
        return {
            ...item,
            llmResponse: {
                ...baseResponse,
                informationPresence,
                documentPresence,
            },
        };
    });
}
function handleExtractionResponse(aiSummaryResponseItems) {
    return (aiSummaryResponseItems = aiSummaryResponseItems.map(item => {
        const baseDocument = {
            documentName: item.llmResponse.document_name || item.llmResponse?.response?.document_name || '',
            documentType: (item.documentType || 'GENERIC_DOCUMENT').toLowerCase(),
        };
        let transformedResponse;
        switch (item.documentType?.toLowerCase()) {
            case 'proof_of_enrollment':
                transformedResponse = {
                    ...baseDocument,
                    studentName: item.llmResponse.student_name || item.llmResponse.response?.student_name || '',
                    schoolName: item.llmResponse.school_name || item.llmResponse.response?.school_name || '',
                    programName: item.llmResponse.program_name || item.llmResponse.response?.program_name || '',
                    termAndYear: item.llmResponse.term_and_year || item.llmResponse.response?.term_and_year || '',
                    startDate: item.llmResponse.start_date || item.llmResponse.response?.start_date || '',
                    endDate: item.llmResponse.end_date || item.llmResponse.response?.end_date || '',
                };
                break;
            case 'proof_of_completion':
                transformedResponse = {
                    ...baseDocument,
                    studentName: item.llmResponse.student_name || item.llmResponse.response?.student_name || '',
                    schoolName: item.llmResponse.school_name || item.llmResponse.response?.school_name || '',
                    programName: item.llmResponse.program_name || item.llmResponse.response?.program_name || '',
                    date: item.llmResponse.date || item.llmResponse.response?.date || '',
                    completionStatus: item.llmResponse.completion_status ||
                        item.llmResponse.response?.completion_status ||
                        '',
                };
                break;
            case 'proof_of_payment':
                transformedResponse = {
                    ...baseDocument,
                    studentName: item.llmResponse.student_name || item.llmResponse.response?.student_name || '',
                    vendorName: item.llmResponse.vendor_name || item.llmResponse.response?.vendor_name || '',
                    itemizedListOfCharges: item.llmResponse.itemized_list_of_charges ||
                        item.llmResponse.response?.itemized_list_of_charges ||
                        [],
                    totalAmount: item.llmResponse.total_amount || item.llmResponse.response?.total_amount || '',
                    transactionDate: item.llmResponse.transaction_date || item.llmResponse.response?.transaction_date || '',
                    paymentMethod: item.llmResponse.payment_method || item.llmResponse.response?.payment_method || '',
                    currency: item.llmResponse.currency || item.llmResponse.response?.currency || '',
                };
                break;
            case 'tuition_bill':
                transformedResponse = {
                    ...baseDocument,
                    studentName: item.llmResponse.student_name || item.llmResponse.response?.student_name || '',
                    schoolName: item.llmResponse.school_name || item.llmResponse.response?.school_name || '',
                    programName: item.llmResponse.program_name || item.llmResponse.response?.program_name || '',
                    termAndYear: item.llmResponse.term_and_year || item.llmResponse.response?.term_and_year || '',
                    totalAmount: item.llmResponse.total_amount || item.llmResponse.response?.total_amount || '',
                    scholarships: item.llmResponse.scholarships || item.llmResponse.response?.scholarships || [],
                    financialAid: item.llmResponse.financial_aid || item.llmResponse.response?.financial_aid || '',
                    costPerCredit: item.llmResponse.cost_per_credit || item.llmResponse.response?.cost_per_credit || '',
                    currency: item.llmResponse.currency || item.llmResponse.response?.currency || '',
                };
                break;
            case 'receipt':
                transformedResponse = {
                    ...baseDocument,
                    itemizedListOfCharges: item.llmResponse.itemized_list_of_charges ||
                        item.llmResponse.response?.itemized_list_of_charges ||
                        [],
                    totalAmount: item.llmResponse.total_amount || item.llmResponse.response?.total_amount || '',
                    transactionDate: item.llmResponse.transaction_date || item.llmResponse.response?.transaction_date || '',
                    vendorName: item.llmResponse.vendor_name || item.llmResponse.response?.vendor_name || '',
                    currency: item.llmResponse.currency || item.llmResponse.response?.currency || '',
                };
                break;
            case 'transcript':
                transformedResponse = {
                    ...baseDocument,
                    studentName: item.llmResponse.student_name || item.llmResponse.response?.student_name || '',
                    schoolName: item.llmResponse.school_name || item.llmResponse.response?.school_name || '',
                    programName: item.llmResponse.program_name || item.llmResponse.response?.program_name || '',
                    itemizedListOfCourses: item.llmResponse.itemized_list_of_courses ||
                        item.llmResponse.response?.itemized_list_of_courses ||
                        [],
                    termAndYear: item.llmResponse.term_and_year || item.llmResponse.response?.term_and_year || '',
                    courseGrades: item.llmResponse.course_grades || item.llmResponse.response?.course_grades || [],
                    courseCredits: item.llmResponse.course_credits || item.llmResponse.response?.course_credits || '',
                    cgpa: item.llmResponse.cgpa || item.llmResponse.response?.cgpa || '',
                };
                break;
            case 'syllabus':
                transformedResponse = {
                    ...baseDocument,
                    school_name: item.llmResponse.school_name || item.llmResponse.response?.school_name || '',
                    programName: item.llmResponse.program_name || item.llmResponse.response?.program_name || '',
                    courseDescription: item.llmResponse.course_description ||
                        item.llmResponse.response?.course_description ||
                        '',
                    courseCredits: item.llmResponse.course_credits || item.llmResponse.response?.course_credits || '',
                    courseId: item.llmResponse.course_id || item.llmResponse.response?.course_id || '',
                    courseRequirements: item.llmResponse.course_requirements ||
                        item.llmResponse.response?.course_requirements ||
                        [],
                    requiredMaterials: item.llmResponse.required_materials ||
                        item.llmResponse.response?.required_materials ||
                        [],
                };
                break;
            default:
                transformedResponse = baseDocument;
                break;
        }
        return {
            ...item,
            llmResponse: {
                error: item.llmResponse.error ||
                    item.llmResponse.response?.error ||
                    item.llmResponse.response?.text ||
                    '',
                ...transformedResponse,
            },
        };
    }));
}
export function transformAiSummaryResponse(aiSummaryResponse, promptCategory) {
    let aiSummaryResponseItems = aiSummaryResponse?.getAiSummary?.items;
    // if promptCategory is VALIDATION, then we need to cast the llmResponse to ValidationResponse
    if (promptCategory === PromptCategory.VALIDATION) {
        aiSummaryResponseItems = handleValidationResponse(aiSummaryResponseItems);
    }
    // if prompt category is EXTRACTION then we need to check the documenttype to know what type of document to cast the llmResponse to
    if (promptCategory === 'EXTRACTION' && aiSummaryResponseItems) {
        aiSummaryResponseItems = handleExtractionResponse(aiSummaryResponseItems);
    }
    return aiSummaryResponseItems;
}
export const parseFilePathIntoFilename = (s3Key) => {
    return s3Key.includes('s3://') ||
        s3Key.includes('/app/backend/') ||
        s3Key.includes('/Users') ||
        s3Key.startsWith('images/')
        ? s3Key.split('/').pop() || s3Key
        : s3Key;
};
export const formatRequestId = (requestId) => {
    if (!requestId.includes('_')) {
        return requestId;
    }
    return requestId
        .split('_')
        .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
        .join(' ');
};
export const formatValue = (value) => {
    if (value === undefined || value === null)
        return '-';
    if (Array.isArray(value)) {
        return (_jsx("div", { children: value.map((item, index) => (_jsx("div", { children: formatValue(item) }, index))) }));
    }
    if (typeof value === 'object') {
        if (value === null)
            return '-';
        if (value instanceof Array) {
            return value
                .map((item, index) => (_jsx("div", { children: formatValue(item) }, index)))
                .join(', ');
        }
        if (value instanceof Object) {
            return (_jsx("table", { className: styles.nestedTable, children: _jsx("tbody", { children: Object.entries(value).map(([key, val]) => (_jsxs("tr", { children: [_jsxs("td", { className: `${styles.nestedTableCell} ${styles.key}`, children: [key, ":"] }), _jsx("td", { className: styles.nestedTableCell, children: formatValue(val) })] }, key))) }) }));
        }
        return (_jsx("table", { className: styles.nestedTable, children: _jsx("tbody", { children: Object.entries(value).map(([key, val]) => (_jsxs("tr", { children: [_jsxs("td", { className: `${styles.nestedTableCell} ${styles.key}`, children: [key, ":"] }), _jsx("td", { className: styles.nestedTableCell, children: formatValue(val) })] }, key))) }) }));
    }
    if (typeof value === 'string') {
        if (value.startsWith('s3://') ||
            value.startsWith('/app/backend/') ||
            value.startsWith('/Users') ||
            value.startsWith('images/')) {
            return parseFilePathIntoFilename(value);
        }
        return value;
    }
    return String(value);
};
export const ErrorDisplay = ({ requestId, error, isCollapsed = true }) => {
    const [collapsed, setCollapsed] = React.useState(isCollapsed);
    return (_jsxs(_Fragment, { children: [_jsx(Alert, { type: 'danger', display: true, className: styles.errorAlert, children: formatRequestId(requestId) }), _jsxs("div", { className: styles.errorHeader, children: [_jsx("span", { children: "Error:" }), _jsx("button", { onClick: () => setCollapsed(!collapsed), className: styles.toggleButton, children: collapsed ? '▼' : '▲' })] }), _jsx("div", { className: `${styles.errorMessage} ${collapsed ? styles.collapsed : ''}`, children: error })] }));
};
export const LoadingState = ({ message = 'Loading...' }) => (_jsx("div", { className: styles.loadingContainer, children: _jsx(Typography, { children: message }) }));
export const NoDataState = ({ message }) => {
    const { t } = useLocale();
    return (_jsxs(Box, { className: styles.noDataContainer, children: [_jsx(Typography, { variant: 'h6', children: t('No Data') }), _jsx(Alert, { type: 'danger', display: true, className: styles.errorAlert, children: message })] }));
};
